// Web override for app/lib/ads.ts. The native variant dynamic-imports
// react-native-google-mobile-ads, which Metro statically bundles even
// when the call site is gated by Platform.OS — and the package can't
// load on web. Metro picks this file automatically for the web target.
export const initializeAds = async (): Promise<void> => {};

export const isAdsInitialized = () => false;

export default { initializeAds, isAdsInitialized };
